import {
  INTERVENANT_LOAD_REQUEST,
  INTERVENANT_MEETING_LOAD_REQUEST,
  INTERVENANT_PATIENT_REQUEST
} from '../constants/ActionTypes';

export const loadIntervenants = oFilters => ({
  type: INTERVENANT_LOAD_REQUEST,
  payload: { oFilters }
});

export const loadIntervenantMeeting = iPKAnnuaire => ({
  type: INTERVENANT_MEETING_LOAD_REQUEST,
  payload: { iPKAnnuaire }
});

export const loadIntervenantsByPatient = (iCodePatient, hour) => ({
  type: INTERVENANT_PATIENT_REQUEST,
  payload: { iCodePatient, hour }
});
